import { useEffect, useId, useMemo, useRef, useState } from 'react'

export function useAssistantMessageContentModel(text) {
  const menuId = useId()
  const retryMenuId = useId()
  const [menuAnchorEl, setMenuAnchorEl] = useState(null)
  const menuOpen = Boolean(menuAnchorEl)
  const [retryAnchorEl, setRetryAnchorEl] = useState(null)
  const retryOpen = Boolean(retryAnchorEl)
  const [feedback, setFeedback] = useState(/** @type {null | 'good' | 'bad'} */ (null))
  const [copied, setCopied] = useState(false)
  const copiedTimerRef = useRef(null)
  const canSpeak = useMemo(() => typeof window !== 'undefined' && 'speechSynthesis' in window, [])

  useEffect(() => {
    return () => {
      if (copiedTimerRef.current) {
        window.clearTimeout(copiedTimerRef.current)
        copiedTimerRef.current = null
      }
    }
  }, [])

  const handleCopy = async () => {
    if (!text) return
    try {
      await navigator.clipboard.writeText(text)
      setCopied(true)
      if (copiedTimerRef.current) window.clearTimeout(copiedTimerRef.current)
      copiedTimerRef.current = window.setTimeout(() => {
        setCopied(false)
        copiedTimerRef.current = null
      }, 3000)
    } catch {
      // No-op: clipboard may be unavailable in some contexts.
    }
  }

  return {
    menuId,
    retryMenuId,
    menuAnchorEl,
    setMenuAnchorEl,
    menuOpen,
    retryAnchorEl,
    setRetryAnchorEl,
    retryOpen,
    feedback,
    setFeedback,
    copied,
    handleCopy,
    canSpeak,
  }
}
